import React, { Component } from 'react';
import ResetForm from '../components/views/Login/PasswordResetInit';

export default ResetForm;
